export let routes = {
  index: '/',
  authenticate: '/authenticate',
  expired: '/session-expired'
};